import React from 'react';
function CornerBottomLeftRadius({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M14.1665 14.1667H10.8481C8.07845 14.1667 5.83317 11.9214 5.83317 9.15174V5.83337"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CornerBottomLeftRadius;
